<template>
  <div class="max-w-md mx-auto w-full">
    <!-- Quick start presets -->
    <div class="mb-8">
      <p class="text-gray-600 mb-3 font-medium text-sm">Start with a preset</p>
      <div class="flex flex-wrap gap-2">
        <button
          v-for="preset in boardPresets"
          :key="preset.name"
          @click="selectPreset(preset)"
          class="px-3 py-1 rounded-full text-sm border text-gray-700 transition-colors"
          :class="value.name === preset.name ? 'border-gray-200' : 'bg-gray-50 hover:bg-white border-gray-50 hover:border-gray-200'"
        >
          {{ preset.name }}
        </button>
      </div>
    </div>

    <form @submit.prevent="createBoard()">
      <div class="space-y-6">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">{{ labelText }}</label>
          <input
            type="text"
            v-model="value.name"
            ref="boardinput"
            class="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow"
            required
          />
        </div>

        <button
          type="submit"
          :disabled="!formValid || isLoading"
          class="w-full bg-[#F54239] min-h-[48px] text-white py-3 px-4 rounded-xl font-medium hover:brightness-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="!isLoading" class="flex items-center justify-center">
            Continue
            <simple-svg :filepath="NextIcon" class="ml-2 w-4 h-4" />
          </span>
          <simple-svg v-else :filepath="LoaderIcon" class="animate-spin w-5 h-5 mx-auto" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import NextIcon from "../images/icons/arrow-right.svg";
import LoaderIcon from "../images/icons/loader.svg";

export default {
  props: ["value", "project"],

  data() {
    return {
      labelText: "Board name",
      isLoading: false,
      NextIcon,
      LoaderIcon,
      boardPresets: [
        {
          name: "💡 Feature Requests",
          intro_heading: "Suggest Features",
          intro_text: "Share your feature ideas",
          form_title_placeholder: "Name your feature",
          form_content_placeholder: "How would this feature help you?"
        },
        {
          name: "🐞 Bug Reports",
          intro_heading: "Report a Bug",
          intro_text: "Help us fix issues",
          form_title_placeholder: "Describe the bug",
          form_content_placeholder: "What steps reproduce this issue?"
        },
        {
          name: "🔗 Integrations",
          intro_heading: "Request Integrations",
          intro_text: "Suggest new integrations",
          form_title_placeholder: "Which integration?",
          form_content_placeholder: "How would this integration benefit your workflow?"
        },
        {
          name: "💬 General Feedback",
          intro_heading: "Share Feedback",
          intro_text: "Help us improve",
          form_title_placeholder: "What's your feedback?",
          form_content_placeholder: "Tell us more about your suggestion"
        }
      ]
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.boardinput.focus();
    });
  },

  methods: {
    selectPreset(preset) {
      this.value.name = preset.name;
      this.presetData = preset; // Store for form submission
    },

    createBoard() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("board[name]", this.value.name);
      formData.append("board[project_id]", this.project.id);

      // Use preset data if available, otherwise use defaults
      const preset = this.presetData || {
        intro_heading: "New idea",
        intro_text: "We value your feedback. You can vote for existing ideas, discuss them or add your own.",
        form_title_placeholder: "Something short",
        form_content_placeholder: "Write about your idea in more detail here"
      };

      formData.append("board[intro_heading]", preset.intro_heading);
      formData.append("board[intro_text]", preset.intro_text);
      formData.append("board[form_title]", "Title");
      formData.append("board[form_title_placeholder]", preset.form_title_placeholder);
      formData.append("board[form_content]", "Description");
      formData.append("board[form_content_placeholder]", preset.form_content_placeholder);
      formData.append("board[form_button_text]", "Add idea");
      formData.append("board[subject_noun]", "post");

      Rails.ajax({
        url: `/projects/${this.project.id}/boards`,
        type: "POST",
        data: formData,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          this.value.id = data.id;
          this.$emit("submit");
        },
        error: (data, status) => {
          console.log(data);
          this.isLoading = false;
        },
      });
    },
  },

  computed: {
    formValid() {
      if (this.value.name.length > 0) {
        return true;
      }

      return false;
    },
  },

  watch: {
    value: {
      deep: true,
      handler: function () {
        this.labelText = "Board name";
      },
    },
  },
};
</script>

<style scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
